// extracted by mini-css-extract-plugin
export var main = "Layout-module--main--580ca";